module.exports = __webpack_public_path__ + "static/media/pl_graphic_permacool.27780a26.png";